import Personal from './Personal';
import Notifications from './Notifications/Notifications';

export {
    Personal,
    Notifications,
};
